import { useContext } from 'react';

import { CollapsiblePanelContext } from './CollapsiblePanelContext';

export const useCollapsiblePanel = () => {
  return useContext(CollapsiblePanelContext);
};
